export const convertDateToFormattedString = (dateString: string, isTime = true) => {
  const inputDate = new Date(dateString)
  const outputDate = `${(inputDate.getMonth() + 1).toString().padStart(2, '0')}/${inputDate.getDate().toString().padStart(2, '0')}/${inputDate.getFullYear().toString().slice(-2)}`
  const outputTime = inputDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
  const finalOutput = `${outputDate} ${isTime ? outputTime : ''}`

  return finalOutput
}
